import { FunctionComponent } from 'react';
import { styled } from 'styled-components';

const StyledNoData = styled.div`
	width: 100%;
	padding: ${({ theme }) => theme.spacing.lg};
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${({ theme }) => theme.colors.textSubtle};
	font-style: italic;
`;

export const NoData: FunctionComponent<{ children: React.ReactNode }> = ({
	children,
}) => <StyledNoData>{children}</StyledNoData>;
